const StoreLocator = function($selector) {
	const module = {
		/**
		 * Options
		 */
		opts: {
			$module: $selector,
			styles: [{"featureType":"all","elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#000000"},{"lightness":40}]},{"featureType":"all","elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#000000"},{"lightness":16}]},{"featureType":"all","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#000000"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#000000"},{"lightness":17},{"weight":1.2}]},{"featureType":"administrative","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"administrative.country","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"administrative.country","elementType":"geometry","stylers":[{"visibility":"simplified"}]},{"featureType":"administrative.country","elementType":"labels.text","stylers":[{"visibility":"simplified"}]},{"featureType":"administrative.province","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"administrative.locality","elementType":"all","stylers":[{"visibility":"simplified"},{"saturation":"-100"},{"lightness":"30"}]},{"featureType":"administrative.neighborhood","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"administrative.land_parcel","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"landscape","elementType":"all","stylers":[{"visibility":"simplified"},{"gamma":"0.00"},{"lightness":"74"}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":20}]},{"featureType":"landscape.man_made","elementType":"all","stylers":[{"lightness":"3"}]},{"featureType":"poi","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":21}]},{"featureType":"road","elementType":"geometry","stylers":[{"visibility":"simplified"}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#000000"},{"lightness":17}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#000000"},{"lightness":29},{"weight":0.2}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":18}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":16}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":19}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":17}]}],
			selectors: {
				map: '.map-element',
				form: '.store-locator-search-form',
				resultsPanel: '.store-locator__results'
			}
		},
		/**
		 * Map variable to store our google maps object and markers
		 */
		map: {},
		/**
		 * The radius our map is currently centered on
		 */
		radius: null,
		/**
		 * The current info window that is open
		 */
		activeInfoWindow: null,
		/**
		 * Method: bindEvents()
		 *
		 * Any onClick or similar events tied to our UI.
		 */
		bindEvents: function() {
			// Search form submit
			this.opts.$module.find(this.opts.selectors.form).on('submit', this.handleSearchSubmit.bind(this));
		},
		/**
		 * Method: init()
		 *
		 * Initialize the entire library.
		 */
		init: function() {
			this.map = this.initMap();
			this.map.infoWindows = [];
			this.map.markers = [];
			this.bindEvents();
			this.initMarkers();
			this.centerMap();
			this.loadInitialState();
		},
		/**
		 * Method: initMap()
		 *
		 * Initializes our Google map
		 *
		 * @returns object
		 */
		initMap: function() {
			const { $module, styles, selectors } = this.opts;
			const map = new google.maps.Map($module.find(selectors.map)[0], {
				zoom : $module.data('zoom') || 8,
				center: { lat: -25.344, lng: 131.031 },
				mapTypeControl: false,
				streetViewControl: false,
				styles
			});
			return map;
		},
		/**
		 * Method: initMarkers()
		 *
		 * Adds all of our markers to the initial map load.
		 */
		initMarkers: function() {
			// Add all markers to initial view
			JSON.parse(window[`${this.opts.$module.parents('.block').attr('id')}_markers`]).forEach(marker => this.addMarker(marker));
		},
		/**
		 * Method: loadInitialState()
		 *
		 * Loads the map based on URL variables.
		 * If no url variables, we simply load all the markers to the map.
		 */
		loadInitialState: function() {
			const queryVars = new URLSearchParams(window.location.search);
			const search = queryVars.get('q') || '';
			const radius = queryVars.get('r') || '50';

			// If we land on the page with url variables, load the initial state of the map
			if (search && search !== '') {
				// Perform the search
				this.doSearch({address: search}, radius);

				// Auto-fill the form fields
				$(`${this.opts.selectors.form} .form-control`).val(search);
				$(`${this.opts.selectors.form} .form-select`).val(radius);

			// Otherwise, we load all the markers
			} else {
				this.showAllMarkers();
			}
		},
		/**
		 * Method: addMarker()
		 *
		 * Creates a single marker and adds to our array.
		 * Note: this method does not actually add the marker to the map visually.
		 *
		 * @param {Array} data
		 */
		addMarker: function(data) {
			const marker = new google.maps.Marker({
				position: {
					lat: parseFloat( data['lat'] ),
					lng: parseFloat( data['lng'] )
				},
				icon: '/wp-content/themes/trimark-framework/dist/images/icons/icon-bo-pin.svg',
				maxWidth: 400
			});

			// Save marker for later use.
			this.map.markers.push( marker );

			// If marker contains HTML, add it to an infoWindow.
			if( data.html.length ){
				this.addInfoWindow(marker, data.html);
			}
		},
		/**
		 * Method: addInfoWindow()
		 *
		 * Adds a google info window to a map marker.
		 *
		 * @param {object} marker
		 * @param {string} content
		 */
		addInfoWindow: function(marker, content) {
			// Create the info window
			const infowindow = new google.maps.InfoWindow({
				content,
			});;

			// Save infowindow for later use
			this.map.infoWindows.push(infowindow);

			// Show info window when marker is clicked.
			google.maps.event.addListener(marker, 'click', () => {
				// If there is already an info window open, close it
				if (this.activeInfoWindow) {
					this.activeInfoWindow.close();
				}

				// Open the info window and save it
				infowindow.open( this.map, marker );
				this.activeInfoWindow = infowindow;
			});

			// On the close event, remove the saved window
			google.maps.event.addListener(infowindow, 'close', () => this.activeInfoWindow = null );
		},
		/**
		 * Method: centerMap()
		 *
		 * Centers the map around all markers.
		 */
		centerMap: function() {
			const bounds = new google.maps.LatLngBounds();
			this.map.markers.forEach(function( marker ){
				bounds.extend({
					lat: marker.position.lat(),
					lng: marker.position.lng()
				});
			});

			// Case: Single marker.
			if( this.map.markers.length == 1 ){
				this.map.setCenter( bounds.getCenter() );

			// Case: Multiple markers.
			} else{
				this.map.fitBounds( bounds );
			}
		},
		/**
		 * Method: showError()
		 *
		 * Shows an error message in the results panel window.
		 *
		 * @param {string} msg
		 */
		showError: function(msg) {
			const { resultsPanel } = this.opts.selectors;
			$(resultsPanel).empty().append(`<div class="error-notice">${msg}</div>`);
		},
		/**
		 * Method: handleSearchSubmit()
		 *
		 * Handles the form submission event.
		 *
		 * @param {event} e
		 * @returns boolean
		 */
		handleSearchSubmit: function(e) {
			const $form = $(e.currentTarget);
			const formData = $form.serializeArray().reduce(function (data, { name, value }) {
				data[name] = value;
				return data;
			}, {});

			// Perform the geo search
			if (formData.q !== '') {
				this.doSearch({address: formData.q}, formData.r);
			} else {
				this.showAllMarkers();
			}

			// Update the url
			window.history.replaceState({} , document.title, '?' + $form.serialize());

			return false;
		},
		/**
		 * Method: doSearch()
		 *
		 * Performs a search for markers on the map given a radius.
		 *
		 * @param {object} geo
		 * @param {int} radius
		 */
		doSearch: function(geo, radius) {
			const geocoder = new google.maps.Geocoder();

			// Reset the radius
			if (this.radius) {
				this.radius.setMap(null);
				this.radius = null;
			}

			// Show the results panel for mobile (always shown for desktop)
			$(this.opts.selectors.resultsPanel).removeClass('js-mobile-hide');

			// Geocode the searched address to a latlng coordinate
			geocoder.geocode(geo)
				.then((result) => {
					const { results } = result;
					const center = results[0].geometry.location;
					const radiusInMiles = parseInt(radius) * 1609.34; // meters to miles
					let storesInRadius = {};

					this.map.setCenter(center);

					this.radius = new google.maps.Circle({
						center,
						radius: radiusInMiles,
						clickable: false,
						map: this.map,
						strokeOpacity: 0,
						fillOpacity: 0,
					});

					if (this.radius) {
						this.map.fitBounds(this.radius.getBounds(), 1)
					}

					// Loop through all markers and add back to map if within radius
					storesInRadius = this.showMarkersInRadius(center, radiusInMiles);

					// Update results panel
					this.updateResultsPanel(storesInRadius, 'search', {radius, address: geo.address});

					return results;
				})
				.catch((e) => {
					console.log('Geocode was not successful for the following reason: ' + e);
					this.showError(`Please enter a valid address, city, state or zip code and try your search again.`);
				});
		},
		/**
		 * Method: showAllMarkers()
		 *
		 * Add all markers to the map.
		 */
		showAllMarkers: function() {
			let allStores = {};

			if (this.map.markers.length > 0) {
				for (let i = 0; i < this.map.markers.length; i++) {
					// Add marker to map
					this.map.markers[i].setMap(this.map);

					// Add store to array
					allStores[i] = {
						marker: this.map.markers[i],
						infoWindow: this.map.infoWindows[i]
					};
				}
			}
			this.centerMap();
			this.updateResultsPanel(allStores, 'showall');
		},
		/**
		 * Method: showMarkersInRadius()
		 *
		 * Shows all markers inside a given radius and returns those stores.
		 *
		 * @param {object} center
		 * @param {float} radius
		 * @returns object
		 */
		showMarkersInRadius: function(center, radius) {
			let storesInRadius = {};

			// Remove all markers first
			if (this.map.markers.length > 0) {
				for (let i = 0; i < this.map.markers.length; i++) {
					this.map.markers[i].setMap(null);
				}
			}

			// Loop through all markers and add back to map if within radius
			if (this.map.markers.length > 0) {
				for (let i = 0; i < this.map.markers.length; i++) {
					const marker = this.map.markers[i];
					const markerLatLng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());
					const distance = google.maps.geometry.spherical.computeDistanceBetween(center, markerLatLng); //distance in meters between your location and the marker
					const distanceInMiles = parseInt(distance) / 1609.34;

					if (distance <= radius) {
						storesInRadius[distanceInMiles] = {
							marker: this.map.markers[i],
							infoWindow: this.map.infoWindows[i]
						};
						this.map.markers[i].setMap(this.map);
					}
				}
			}

			return storesInRadius;
		},
		/**
		 * Method: updateResultsPanel()
		 *
		 * Updates the results sidebar with a given list of stores.
		 * Content is grabbed from the map infoWindow()s
		 *
		 * @param {object} stores
		 * @param {string|null} flag
		 * @param {object|null} search
		 * @returns void
		 */
		updateResultsPanel: function(stores, flag = null, search = null) {
			let count = 1;
			const { $module } = this.opts;
			const { resultsPanel } = this.opts.selectors;

			// Empty results
			$module.find(resultsPanel).empty().scrollTop(0);

			if (Object.keys(stores).length === 0) {
				this.showError(`We couldn't find any stores within <strong>${search.radius} miles</strong> of <strong>${search.address}</strong>.`);
				return;
			}

			// Sort by distance
			const storesSortedByDistance = Object.keys(stores).sort((a, b) => a - b);

			// Add results to results window in sidebar
			storesSortedByDistance.forEach(mileage => {
				const $infoWindowContent = $(stores[mileage].infoWindow.getContent());

				// $infoWindowContent.find('.store-info-window__loc .number').text(count);

				if (flag !== 'showall') {
					$infoWindowContent.find('.store-info-window__loc .number').html(Math.round(mileage) + '<span>mi</span>');
					// $infoWindowContent.find('.store-info-window__loc .mileage').text(Math.round(mileage) + ' mi');
				} else {
					$infoWindowContent.find('.store-info-window__loc .number').text('');
				}

				$module.find(resultsPanel).append($infoWindowContent);

				stores[mileage].infoWindow.setContent($infoWindowContent[0].outerHTML);

				count++;
			});
		}
	}

	if ($selector.length && typeof google !== 'undefined') {
		module.init();
	}

	return module;
}


/**
 * Register after jQuery doc ready
 */
$(() => {
	new StoreLocator($('.store-locator'));
});
